import {axios} from "../mixins/axiosDefault";

window.$axios = axios;

let token = document.head.querySelector('meta[name="csrf-token"]');

const apiAxios = axios.create({
    withCredentials: true,
    withXSRFToken: true,
});

apiAxios.interceptors.request.use((config) => {
    config.headers['X-XSRF-TOKEN'] = token.content;
    config.headers['Accept'] = 'application/json';
    return config;
});
apiAxios.CancelToken = axios.CancelToken.source();
window.$api = apiAxios;


